import {helpLink, supportEmail, systemStatusLink} from "@hosttools/core/constant";
import {
    CommentIcon,
    DashboardIcon,
    EnvelopeIcon,
    QuestionIcon,
    QuestionSolidIcon
} from "@hosttools/frontend";
import type {DropdownItemType} from "@hosttools/frontend/components";
import {
    Center,
    Dropdown,
    DropdownItemLink,
    DropdownMenuItem,
    useDefaultTrigger,
    useDropdownMenuClickCallback
} from "@hosttools/frontend/components";
import type React from "react";
import {memo, useMemo} from "react";

type Props = {
    onSupport: () => void;
};

const SupportIcon = (
    <Center
        className={`
        cursor-pointer
        size-6
        border
        border-solid
        border-blueGray-200
        bg-blueGray-50
        rounded-full
    `}
    >
        <QuestionIcon fill="blueGray.600" size="2xs" />
    </Center>
);

export const SupportMenu: React.FC<Props> = ({onSupport}) => {
    const handleClickItem = useDropdownMenuClickCallback();

    const menuDisplay = useMemo<DropdownItemType[]>(
        () => [
            {
                Icon: QuestionSolidIcon,
                label: "Help Center",
                link: helpLink,
                type: "external"
            },
            {
                Icon: DashboardIcon,
                label: "Running Status",
                link: systemStatusLink,
                type: "external"
            },
            {
                Icon: CommentIcon,
                label: "Chat with us",
                onPress: onSupport
            },
            {
                Icon: EnvelopeIcon,
                label: "Contact us",
                link: `mailto:${supportEmail}`,
                type: "external"
            }
        ],
        [onSupport]
    );

    return (
        <Dropdown
            className="min-w-64"
            placement="bottom right"
            trigger={useDefaultTrigger(SupportIcon, false, undefined, "Support")}
        >
            {menuDisplay.map(menu => (
                <DropdownMenuItem key={menu.label} onPress={() => handleClickItem(menu)}>
                    <DropdownItemLink key={menu.label} size="sm" {...menu} />
                </DropdownMenuItem>
            ))}
        </Dropdown>
    );
};

export default memo(SupportMenu);
